// extracted by mini-css-extract-plugin
export default {"line":"courseInfo_line__4-drw","bg":"courseInfo_bg__+AC7X","main":"courseInfo_main__Z4CJl"};